import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskGettingStartedSlaRoute: InvariantJiraRoute = {
	name: 'servicedesk-getting-started-sla',
	path: '/jira/servicedesk/projects/:projectKey/getting-started/sla',
	exact: true,
};
